import { EventTypes } from 'redux-segment';

import { CLEAN_CASHUP_DATA } from './feCleanCashupData.types';

const feCleanCashupData = () => ({
  type: CLEAN_CASHUP_DATA,
  meta: { analytics: EventTypes.track },
});

export default feCleanCashupData;
